import { Box, Container, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { SendCodeRequest } from 'apis/auth/types';
import { useSendEmailForCode } from 'apis/auth/hook';
import Input from 'components/Common/Input';
import Button from 'components/Common/Button';
import { loginSchema } from './ValidationSchema';
import { getCookie } from 'utils/helperFunctions';
import { CacheKeys } from 'utils/cacheKeys';
import { Navigate } from 'react-router-dom';
import { useGetOrganizations } from 'apis/agency/organizations/hook';

export default function Login() {
  const { control, handleSubmit } = useForm<SendCodeRequest>({
    resolver: zodResolver(loginSchema),
    mode: 'onBlur'
  });
  const isAuthenticated = Boolean(getCookie(CacheKeys.authToken));

  const { mutate: sendVerificationCode, isPending } = useSendEmailForCode();
  const { data: organizations } = useGetOrganizations();

  const onSubmit = (data: SendCodeRequest) => {
    sendVerificationCode(data);
  };

  if (isAuthenticated) {
    return <Navigate to='/' state={window.location.href} />;
  }

  return (
    <Container
      maxWidth='xs'
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      <Box
        sx={{
          textAlign: 'center'
        }}
      >
        <img src={organizations?.logo_url} alt='app-logo' height={72} />
        <Typography variant='h1' fontWeight={500} mt={3}>
          Sign Up / Log In to Your Account
        </Typography>
      </Box>
      <Box
        component='form'
        sx={{ width: '100%', maxWidth: '100%' }}
        noValidate
        autoComplete='off'
        onSubmit={handleSubmit(onSubmit)}
      >
        <Input
          name='email'
          label='Email address'
          type='email'
          margin='normal'
          control={control}
          fullWidth
          autoComplete='email'
        />
        <Button type='submit' variant='contained' color='primary' fullWidth sx={{ mt: 3 }} isPending={isPending}>
          Next
        </Button>
      </Box>
    </Container>
  );
}
